import { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import "../../../style/style-cargando.css";
import cargandoCard from "../../../components/cargando-card";
// import sinAccesoCard from "../../../components/sin-acceso-card";
import { AgGridReact } from "ag-grid-react";
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';
import "../../../style/style-ag-grid.css";
import { ESTILO_BOTON_LISTAR_ATRAS, ESTILO_BOTON_MODAL_ACEPTAR } from "../../../utils/const/estilos-const";
import moment from "moment";
import { obtenerEventosEmpresaPlataforma } from "../../../api/api-empresa-plataforma";
// import { sharedNextPage } from "../../../utils/shared-functions";
ModuleRegistry.registerModules([AllCommunityModule]);

export default function EventosEmpresaPage() {

    const history = useHistory();
    const location = useLocation();
    const [cargandoPage, setCargandoPage] = useState(true);
    // const [titulo, setTitulo] = useState("");
    const [rowData, setRowData] = useState([]);

    const columnDefs = [
        {
            key: "acciones", headerName: "ACCIONES", width: 250,
            cellRenderer: (params) => {
                // console.log('cellRenderer');
                // console.log(params);
                return (
                    <div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
                        {/* <button
                            onClick={() => handleEdit(params.data)}
                            style={{
                                backgroundColor: "#1E90FF",
                                color: "white",
                                border: "none",
                                padding: "5px 10px",
                                cursor: "pointer",
                                borderRadius: "5px",
                            }}
                        >
                            {t("label_edit")}
                        </button> */}
                    </div>
                );
            }
        },
        { field: "id", headerName: "ID", hide: true },
        { field: "idactivo", headerName: "ID ACTIVO", filter: true, sortable: true, },
        { field: "nombre", headerName: "NOMBRE", filter: true, sortable: true, },
        { field: "fechaprimerreporte", headerName: "FECHA PRIMER REPORTE", filter: true, sortable: true, width: 250, },
        { field: "fechaultimoreporte", headerName: "FECHA ULTIMO REPORTE", filter: true, sortable: true, width: 250, },
    ];

    useEffect(() => {
        iniciar();
    }, []);

    const iniciar = async () => {
        try {
            const data = location.state;
            // console.log("data");
            // console.log(data);
            const fechaInicio = moment().startOf("month").format("YYYY-MM-DD");
            const fechaFin = moment().endOf("month").format("YYYY-MM-DD");
            let objEnviar = {};
            objEnviar.fechaInicio = fechaInicio;
            objEnviar.fechaFin = fechaFin;
            objEnviar.id = data.idEmpresa;
            // let permiso = null;
            const response = await obtenerEventosEmpresaPlataforma(objEnviar)
            // console.log("response", response);
            // lista = await getListVehiculo();
            // console.log('lista');
            // console.log(lista);
            agregarAccionesALista(Array.isArray(response.body) ? response.body : [], null);
            // setTieneAccesoAlModulo(true);
            setCargandoPage(false);
        } catch (err) {
            console.log('iniciar err');
            console.log(err);
            setCargandoPage(false);
        }
    };

    const agregarAccionesALista = (lista, permiso) => {
        try {
            setRowData(lista);
        } catch (err) {
            console.log('agregarAccionesALista err');
            console.log(err);
        }
    };

    const handleAtrasClick = () => {
        history.goBack();
    };

    const reset = async () => {
        setCargandoPage(true);
        iniciar();
    };

    const render = () => {
        try {
            // console.log('listar correo render');
            if (cargandoPage === true) {
                return cargandoCard();
            }
            return (
                <div className="pt-4 px-4">
                    <div className="flex justify-between">
                        <label
                            style={{
                                fontWeight: 'bold',
                            }}
                        >
                            EVENTOS
                        </label>
                        <div className="flex justify-center">
                            <button
                                type="button"
                                className={ESTILO_BOTON_LISTAR_ATRAS}
                                onClick={(handleAtrasClick)}
                            >
                                ATRAS
                            </button>
                        </div>
                    </div>
                    <div className="flex justify-between gap-4">
                        {/* Button (3/12 columns) */}
                        <div className="flex items-end">
                            <button
                                type="button"
                                className={`${ESTILO_BOTON_MODAL_ACEPTAR} w-full`}
                                onClick={() => reset()}
                            >
                                BUSCAR
                            </button>
                        </div>
                    </div>
                    <div
                        className="ag-theme-alpine pt-4"
                        style={{
                            height: "512px",
                            width: "100%",
                            // "--ag-header-background-color": `${primaryColor}`,
                        }}
                    >
                        <AgGridReact
                            rowData={rowData}
                            columnDefs={columnDefs}
                            pagination={true}
                            rowHeight={50}
                        />
                    </div>
                </div>
            );
        } catch (err) {
            console.log('EventosEmpresaPage render err');
            console.log(err);
            return (
                <div><label>{JSON.stringify(err)}</label></div>
            );
        }
    }

    return render();
}
